import { QuestionnaireBlueprint, RenderingQuestionnaire } from '@zinnia/form-engine-sdk';

import { ComprehensivePricing } from '../comprehensivePricing';
import { ESignSigner } from '../esign';
import {
  AdvisorEntity,
  AnnuitantEntity,
  OwnerEntity,
  PayerEntity,
  ProductsEntity,
  ProposedInsuredEntity,
} from '../insuranceEntities';
import { Application } from '../models/application';
import { ApplicationPointOfSaleDecisions } from '../pointOfSaleDecision';
import { ProductAddon } from '../products';

export type DynamicPdfDataGetRequest<TQuestionnaire, TAnswerPath> = {
  application: Application;
  questionnaire: TQuestionnaire;
  blueprint: QuestionnaireBlueprint;
  nodeIdToAnswerPathMap: [string, TAnswerPath][];
  entities: DynamicPdfInsuranceEntities;
  eSignSigners: ESignSigner[] | undefined;
  addons: ProductAddon[] | undefined;
  pointOfSaleDecisions: ApplicationPointOfSaleDecisions;
  participantWithMedicalInterviewAnswers?: { fullName: string; answers: RenderingQuestionnaire };
};

export type DynamicPdfInsuranceEntities = {
  proposedInsureds: ProposedInsuredEntity[];
  owners: OwnerEntity[];
  payers: PayerEntity[];
  advisors: AdvisorEntity[];
  annuitant: AnnuitantEntity | null;
  products: ProductsEntity;
  comprehensivePricing?: ComprehensivePricing;
};

// TODO:  Refactor typing: https://breathelife.atlassian.net/browse/DEV-10756
export enum DynamicPdfType {
  insured = 'user',
  carrier = 'carrier',
  advisor = 'advisor',
  medicalInterviewAnswers = 'medicalInterviewAnswers',
}
